
// Handle livewire 'toast' event
if(typeof window.Livewire === 'object'){
    Livewire.on('toast', options => {
		options = options[0];

        if(typeof options.message === 'undefined' || options.message === null || options.message === ''){
			return;
		}

		let message = options.message;
		// Defaults
		let title = null;
		let type = 'default';
		let duration_ms = 0;

		if(typeof options.title === 'string' && options.title !== '' ){
			title = options.title;
		}

		if(typeof options.type === 'string' && typeof toast[options.type] === 'function' ){
			type = options.type;
		}

		if(typeof options.duration_ms === 'number'){
			duration_ms = options.duration_ms;
		}

		if(duration_ms){
			toast.showToast(message, title, type, duration_ms);
		}
		else{
			toast[options.type](message, title);
		}

    });
}

const toast = {
	headerTextTypeMap: {
		'success': 'Success',
		'danger' : 'Error',
		'primary': 'Info',
		'warning': 'Warning',
		null 	 : 'Notification'
	},
    success: function(message, title = null) {
        this.showToast(message, title, "success", 7000);
    },
    error: function(message, title = null) {
        this.showToast(message, title, "danger");
    },
    info: function(message, title = null) {
        this.showToast(message, title, "primary", 7000);
    },
    warning: function(message, title = null) {
        this.showToast(message, title, "warning", 12000);
    },
	default: function(message, title = null) {
		this.showToast(message, title, null, 7000);
	},
	defaultOptions: {
		animation: true,
		autohide: false,
		delay: 0,
		type: null,

	},
    showToast: function(message, title, type = null, duration_ms = 0) {
        if(typeof message === 'undefined' || message === null || message === '') {
			console.error('[Toast] No message was provided.');
			return;
		}

		// Set default options
		let options = {
			...this.defaultOptions,
			// Set to automatically hide if a duration is provided
			autohide: (duration_ms !== 0),
			delay: Math.abs(duration_ms),
			type: type,
		};

		// Get the toast template
        let template = document.getElementById("toast-template");
        if (!template) {
            console.error("Toast template not found!");
            return;
        }

        // Clone the toast
        let newToast = template.cloneNode(true);
		let toastHeader = newToast.querySelector(".toast-header");
		let toastBody = newToast.querySelector(".toast-body");
        newToast.id = `toast-${Date.now()}`; // Assign a unique ID


		// Set the color scheme
		if(type !== null){
			toastHeader.classList.add('text-bg-' + type); // Apply the correct color
		}

		// Set the title
		if(title === null){
			title = this.headerTextTypeMap[type];
			// title = type.charAt(0).toUpperCase() + type.slice(1);
		}

		// Set the header
		toastHeader.querySelector('.toast-header-text').textContent = title;

		// Insert the message
		toastBody.innerHTML = message;

        // Append to the toast container
        let container = document.getElementById("toast-container");
        container.appendChild(newToast);

        // Initialize Bootstrap toast instance
        let bsToast = new bootstrap.Toast(newToast, options);
        bsToast.show();

        // Remove the toast after it disappears
        newToast.addEventListener("hidden.bs.toast", function () {
            newToast.remove();
        });
    }
};

document.addEventListener('DOMContentLoaded', function(event) {
	let closeAllButton = document.getElementById("close-all-toasts");
	closeAllButton.addEventListener('click', function(){
		document.querySelectorAll(".toast.show .btn-close").forEach(function(button){
			button.click();
		})
	});
}, false);

export default toast;